var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#25292D",
    d: "M9.059 9.426v3.043a.5.5 0 0 0 .5.5h2.985a.5.5 0 0 0 .5-.5v-6.06a.5.5 0 0 0-.188-.39l-4.272-3.41a.5.5 0 0 0-.624 0L3.688 6.02a.5.5 0 0 0-.188.39v6.06a.5.5 0 0 0 .5.5h2.985a.5.5 0 0 0 .5-.5V9.426h1.574zM8.272 3.64l3.772 3.01v5.319h-1.985V8.926a.5.5 0 0 0-.5-.5H6.985a.5.5 0 0 0-.5.5v3.043H4.5v-5.32l3.772-3.01z"
  })));
};
export default SvgHome;